module.exports = "pegasus/assets/blocks/column-lp15-themelp1.png";